<script lang="ts" setup>
import { useFeatureToggle } from '@environment/useFeatureToggle';
import VChip, { type VChipProps } from '@shared/component/VChip/VChip.vue';
import { usePortefeuilleGetCrvp } from '@services/aanvragen-public/orval-api/portefeuille/portefeuille';
import { computed } from 'vue';
import { tryMenuNavigation } from '../../urlHelper';

const nieuweUrlToggle = useFeatureToggle('PortefeuilleDashboardToggle');

function handleClick(event: Event) {
  if (!nieuweUrlToggle.value) {
    tryMenuNavigation(event);
  }
}

const { data: crvpData, isPending: crvpPending } = usePortefeuilleGetCrvp({
  query: {
    select: (e) => e.result,
  },
});

const crvpHuidigJaar = computed(() => crvpData.value?.crvpHuidigJaar);

const crvpChipProps = computed<Pick<VChipProps, 'color' | 'icon'>>(() => {
  const jaar = crvpHuidigJaar.value;

  if (jaar === undefined) {
    return {
      color: undefined,
      icon: ['far', 'gauge'],
    };
  }
  if (jaar <= 80) {
    return {
      color: 'teal',
      icon: ['far', 'gauge-min'],
    };
  }
  if (jaar <= 100) {
    return {
      color: 'orange',
      icon: ['far', 'gauge'],
    };
  }
  return {
    color: 'red',
    icon: ['far', 'gauge-max'],
  };
});

const crvpHuidigJaarLabel = computed(() => {
  const jaar = crvpHuidigJaar.value;
  return jaar !== undefined ? `${jaar}%` : '-';
});
</script>

<template>
  <a
    class="flex items-center no-underline"
    :href="
      nieuweUrlToggle
        ? '/app/aanvraag/rapportage/portefeuilledashboard'
        : '/net/rapportageintern/portefeuilledashboard'
    "
    @click="handleClick"
  >
    <VChip
      v-bind="crvpChipProps"
      :label="crvpHuidigJaarLabel"
      :pending="crvpPending"
      hide-icon="md"
    />
  </a>
</template>
